import { Directive } from '@angular/core';

@Directive({
  selector: 'sim-form-actions',
  host: {
    class: 'sim-form-actions'
  }
})
export class SimFormActionsDirective {}
